import useSWR, { SWRResponse } from 'swr';
import type { AxiosError } from 'axios';
import { Agent, ManagerRank } from '../../../providers/api/dtos';
import { getManagerRank } from '../../../providers/api/manager-rank/managerRankProvider';

export const MANAGER_RANK_V1_RID = '/v1/rankings/manager/:agentId';

export default function useManagerRank(agentId?: Agent['id']): SWRResponse<ManagerRank, AxiosError> {
  return useSWR(agentId ? [MANAGER_RANK_V1_RID, agentId] : null, () => getManagerRank(agentId!));
}
